module.exports = __webpack_public_path__ + "img/tips1.cca8d3e7.png";